import React, { useState } from "react";
import PackageImageUploadModal from "../../../Pages/Shipper/Customer/MainPages/Shipments/Components/PackageImageUploadModal/PackageImageUploadModal";
import BoltButton from "../../UI/Buttons/BoltButton";
import { IoMdWarning } from "react-icons/io";
import { MdPending } from "react-icons/md";
import { useTranslation } from "react-i18next";

const OneTimeShipperImageStatus = ({
  shipmentData,
  onImageUploadSuccess,
  refreshShipmentData,
}) => {
  const { t } = useTranslation("finances");
  const [packageImageUploadModal, setPackageImageUploadModal] = useState(false);

  if (!shipmentData) return null;

  if (shipmentData?.shipment_type !== "oneTimeShipper") {
    return null;
  }

  const hasImages =
    shipmentData?.one_time_package_images &&
    Array.isArray(shipmentData.one_time_package_images) &&
    shipmentData.one_time_package_images.length > 0;

  if (!hasImages) {
    return (
      <>
        <div className="my-5 mx-4 p-4 bg-state-warning-bg border border-state-warning-border rounded-lg flex items-center gap-3 flex-wrap">
          <div className="flex-shrink-0">
            <IoMdWarning
              className="icon__status_boltTable"
              style={{ color: "rgb(var(--color-danger))" }}
              size={20}
            />
          </div>
          <div className="flex-1 min-w-0">
            <div className="font-semibold text-sm text-ui-text mb-1">
              {t("invoice.oneTime.imagesRequired")}
            </div>
            <div className="text-xs text-ui-text-muted leading-relaxed">
              {t("invoice.oneTime.imagesRequiredBody")}
            </div>
          </div>
          <BoltButton
            label={t("invoice.oneTime.uploadImages")}
            onClick={() => setPackageImageUploadModal(true)}
            variant="primary"
            size="md"
          />
        </div>
        <PackageImageUploadModal
          open={packageImageUploadModal}
          onClose={() => {
            setPackageImageUploadModal(false);
          }}
          shipment={shipmentData}
          onSuccess={() => {
            setPackageImageUploadModal(false);
            if (refreshShipmentData && shipmentData?.id) {
              setTimeout(() => {
                refreshShipmentData(shipmentData.id);
              }, 500);
            }
            if (onImageUploadSuccess) {
              onImageUploadSuccess();
            }
          }}
        />
      </>
    );
  }

  return (
    <div className="my-5 mx-4">
      <div className="p-4 bg-brand-light border border-brand rounded-lg flex items-center gap-3 mb-3">
        <div className="flex-shrink-0">
          <MdPending
            className="icon__status_boltTable"
            style={{ color: "var(--color-info-text)" }}
            size={20}
          />
        </div>
        <div className="flex-1">
          <div className="font-semibold text-sm text-ui-text mb-1">
            {t("invoice.oneTime.pendingApproval")}
          </div>
          <div className="text-xs text-ui-text-muted leading-relaxed">
            {t("invoice.oneTime.pendingBody")}
          </div>
        </div>
      </div>
      {hasImages && (
        <div className="mt-3">
          <div className="text-sm font-semibold text-ui-text mb-2">
            {t("invoice.oneTime.uploadedImages", {
              n: shipmentData.one_time_package_images.length,
            })}
          </div>
          <div className="grid grid-cols-[repeat(auto-fill,minmax(120px,1fr))] gap-3">
            {shipmentData.one_time_package_images.map((imageItem, index) => (
              <div
                key={imageItem.id || index}
                className="relative w-full pt-[100%] bg-ui-surface-sunken rounded-lg overflow-hidden border border-ui-border group"
              >
                <img
                  src={imageItem.image}
                  alt={
                    imageItem.image_name ||
                    t("invoice.oneTime.imageAlt", { n: index + 1 })
                  }
                  className="absolute top-0 left-0 w-full h-full object-cover"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-colors" />
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default OneTimeShipperImageStatus;
